import { EFormFieldInputTypes } from "app/Components/Form/FormField.component";
import { isBetween, YYYYMMDDFormat } from "app/_helpers/dateHelper";
import { TRAINEE_TYPE } from "../TrainingManagement/CONSTANTS";

export const MEDICAL_STATUS_VIEW = {
  all: "All",
  due: "Due",
  overDue: "Over Due",
  inProgress: "In Progress",
  soReview: "SO Review",
  mmReview: "MM Review",
  approved: "Approved",
};

export const MEDICAL_STATUS = {
  all: "all",
  due: "due",
  overDue: "overDue",
  soReview: "soReview",
  mmReview: "mmReview",
  inProgress: "inProgress",
  approved: "approved",
};

export const MEDICAL_PROGRESS_CHECK = ["soReview", "mmReview", "inProgress"];

export function capitalLabel(val) {
  return val == "due"
    ? "Due"
    : val == "mmReview"
    ? "MM Review"
    : val == "all"
    ? "All"
    : val == "inProgress"
    ? "In Progress"
    : val == "approved"
    ? "Approved"
    : val == "fit"
    ? "Fit"
    : val == "unfit"
    ? "Unfit"
    : val == "underReview"
    ? "UnderReview"
    : val == "overdue"
    ? "Overdue"
    : val == "ime"
    ? "IME"
    : val == "pme"
    ? "PME"
    : val == "sme"
    ? "SME"
    : val == "fit"
    ? "Fit"
    : val == "unfit"
    ? "Unfit"
    : val == "underReview"
    ? "UnderReview"
    : val == "overdue"
    ? "Overdue"
    : val == "employee"
    ? "Employee"
    : val == "contractorPerson"
    ? "Contractor Person"
    : val;
}

export const MEDICAL_REPORT_STATUS = {
  all: "all",
  fit: "fit",
  unfit: "unfit",
  underReview: "underReview",
  overdue: "overdue",
};

export const MEDICAL_REPORT_STATUS_VIEW = {
  all: "All",
  fit: "Fit",
  unfit: "Unfit",
  underReview: "Under Review",
  overdue: "Overdue",
};

export const MEDICAL_TYPE = {
  ime: "ime",
  pme: "pme",
  sme: "sme",
};

export const MEDICAL_TYPE_VIEW = {
  ime: "IME",
  pme: "PME",
  sme: "SME",
};

export const commentTypes = {
  investigation: "Investigation",
  review: "Review",
  closure: "Closure",
  medical: "Medical",
};

export const MEDICAL_TYPE_OPTION = Object.keys(MEDICAL_TYPE).map((key) => ({
  label: MEDICAL_TYPE_VIEW[key],
  id: key,
}));

const newSMEFormLabelObj = {
  // 1. Manganese Exposure

  significantManganeseExposure: "Significant Manganese Exposure",
  neurologicalDisturbancesObservations: "Neurological Disturbances Observations",
  behaviouralDisturbancesObservations: "Behavioural Disturbances Observations",
  speechDefectObservations: "Speech Defect Observations",
  tremorObservations: "Tremor Observations",
  impairmentOfEquilibrium: "Impairment of Equilibrium",
  adiadochokinesiaH2SObservations: "Adiadochokinesia H2S Observations",
  emotionalObservations: "Emotional Observations",
  manganeseEnclosedReports: "Enclosed Reports",

  // 2. Lead Exposure
  significantLeadExposure: "Significant Lead Exposure",
  bloodLeadCount: "Blood Lead Count (ug/DL)",
  bloodLeadAnalysisObservations: "Blood Lead Analysis Observations",
  deltaAminolevulinicAcidCount: "Delta Aminolevulinic Acid Count (mg)",
  deltaAminolevulinicAcidObservations: "Delta Aminolevulinic Acid Observations",
  leadEnclosedReports: "Enclosed Reports",

  // 3. Ionizing Radiation Exposure
  significantRadiationExposure: "Significant Radiation Exposure",

  radiationBloodCount: "Radiation Blood Count",
  bloodRadiationObservations: "Blood Radiation Observations",
  pathologicalManifestationObservations: "Pathological Manifestation Observations",
  ionizingEnclosedReports: "Enclosed Reports",

  // 4. Food Handling & Stemming Material
  foodHandingExposure: "Food Handing & Stemming Material Exposure",
  routineStoolTestObservations: "Routine Stool Test Observations",
  AFPSputum: "AFP Sputum",
  AFPSputumAnalysis: "AFP Sputum Analysis",
  chestRadiographObservations: "Chest Radiograph Observations",
  foodHandingEnclosedReports: "Enclosed Reports",

  // 5. Driving/HEMM Operations
  drivingOperationsExposure: "Driving/HEMM Operations Exposure",
  drivingHandingEnclosedReports: "Enclosed Reports",
  refractiveError: "Refractive Error",
  correctedWithGlasses: "Corrected with Glasses",

  // 6. Noise Exposure
  significantNoiseExposure: "Significant Noise Exposure",
  audiometryAnalysis: "Audiometry Analysis",
  noiseRemarks: "Remarks",
  noiseEnclosedReports: "Enclosed Reports",

  // 7. Chemicals Exposure
  significantChemicalsExposure: "Significant Chemicals Exposure",
  anyDirectContactWithChemicals: "Any direct contact with Chemicals",
  contactDermatitisObservations: "Contact Dermatitis Observations",
  chemicalsRemarks: "Remarks",
  chemicalsEnclosedReports: "Enclosed Reports",

  // 8. Pneumoconiosis Information
  pneumoconiosisSymptoms: "Pneumoconiosis Symptoms",
  pneumoconiosisObservations: "Pneumoconiosis Observations",
  siderosisObservations: "Siderosis Observations",
  berillyosisObservations: "Berillyosis Observations",
  anyOtherObservation: "Any other Observation",
  pneumoconiosisRemarks: "Remarks",
  pneumoconiosisEnclosedReports: "Enclosed Reports",

  // 9. Special Remarks
  finalObservations: "Final Observations",
  anySpecialTestRequired: "Any Special Test Required",
  specialRemarks: "Special Remarks",
};

export const employeeFormLabel = {
  medicalAssigneeType: "Employee/Contractor Person",
  dueDate: "Due Date",
  medicalResult: "Medical Result",
  medicalTestType: "Medical Type",
  identificationMark: "Identification Mark",
  generalDevelopment: "General Development",
  height: "Height (In CMS)",
  weight: "Weight (In KG)",
  address: "Address",
  contact: " Emergency contact",
  remarks: "Remarks",

  // eyes
  visualAcuity: "Visual acuity- Distant vision (With/without glasses)",
  visualAcuityLeftEye: "Left Eye",
  visualAcuityRightEye: "Right Eye",
  organicDiseaseOfEyes: "Any Organic Disease of Eyes",

  nightBlindness: "Night Blindness",
  colourBlindness: "Colour Blindness",
  squint: "Squint",
  testForSquintPerformed: "Test for Squint Performed",

  //Ears:
  hearing: "Hearing",
  hearingLeftEar: "Left ear",
  hearingRightEar: "Right ear",
  organicDiseaseOfEar: "Any Organic Diseases",

  chestMeasurement: "Chest Measurement",
  chestAfterFullInspiration: "After Full Inspiration (In CMS)",
  chestAfterFullExpiration: "After Full Expiration (In CMS)",

  // Circulatory system:
  bloodPressure: "BP - Systolic (In mmHg)",
  bloodPressureDiastolic: "BP – Diastolic (In mmHg)",
  pulse: "Pulse (In min)",

  // Abdomen
  tenderness: "Tenderness",
  liver: "Liver",
  spleen: "Spleen",
  tumor: "Tumor",

  // Nervous system:
  epilepsy: "History of Fits or Epilepsy",
  paralysis: "Paralysis",
  mentalHealth: "Mental health",

  locomotorySystem: "Locomotory System",
  skin: "Skin",
  hydrocele: "Hydrocele",
  hernia: "Hernia",
  anyOtherAbnormality: "Any Other Abnormality",

  // Urine:
  reaction: "Reaction",
  albumin: "Albumin",
  sugar: "Sugar",

  skiagramOfChest: "Skiagram of Chest",
  anyOtherTest: "Any Other Test Considered Necessary by Examining Authority",
  anyOpinion: "Any Opinion of Specialist Considered Necessary",

  // Special Remarks
  isSufferingFrom: "Is Suffering From",
  reExaminationRequirement: "Re-Examination Requirement",
  repeatExaminationAfter: "Repeat Examination After",
  phyisicanSpecialist: "Phyisican Specialist Opinion Required",
  permittedDuties: "Permitted for Duties",

  // General Info
  medicalAssigneeId: "Employee ID/Contractor ID",
  employeeName: "Name of the Employee",
  fatherName: "Fathers Name/Spouse Name",
  dob: "Date of Birth",
  identificationMarks: "Identification Marks",
  aadharNumber: "Aadhar Number",
  categoryId: "Category",
  subCategoryId: "Sub- Category",

  // Cardiological Assessment:
  // i. Auscultation:
  auscultationS1: "S1",
  auscultationS2: "S2",
  additionalSound: "Additional Sound",
  electrocardiogram: "Electrocardiogram 12 Leads Findings",

  // Neurological Assessment:
  superficialReflexes: "Superficial Reflexes",
  deepReflexes: "Deep Reflexes",
  peripheralCirculation: "Peripheral Circulation",
  vibrationalSyndromes: "Vibrational Syndromes",

  // ILO Classification of Chest Radiograph:
  profusion: "Profusion of Pneumoconiotic Opacities",
  grades: "Grades",
  types: "Types",
  enclosedChestRadiograph: "Enclosed Chest Radiograph",

  // Audiometry Findings:
  // conductionType: "Conduction type"
  // Ear Conduction
  leftEarConduction: "Left Ear",
  rightEarConduction: "Right ear",
  //  ii. Bone Conduction
  leftEarBoneConduction: "Left Ear",
  rightEarBoneConduction: "Right ear",
  enclosedAudiometryReport: "Enclosed Audiometry Report",

  // Pathological/Microbiological Investigations:
  blood: "Blood (Tc)",
  bloodDc: "Blood (Dc)",
  bloodHb: "Blood (Hb)",
  bloodESR: "Blood (ESR)",
  bloodPlatelets: "Blood (Platelets)",

  bloodSugar: "Blood Sugar Fasting",
  bloodSugarPP: "Blood Sugar PP",
  lipidProfile: "Lipid Profile",
  bloodUrea: "Blood Urea",
  creatinine: "Creatinine/LFT",
  urineRoutine: "Urine Routine",
  stoolRoutine: "Stool Routine",
  enclosedInvestigationReport: "Enclosed Investigation Report",

  // Special Test for Mn Exposure:
  behaviorDisturbances: "Behavior Disturbances",
  // neurologicalDisturbances:"Neurological Disturbances",
  speechDefect: "Speech Defect",
  tremor: "Tremor",
  adiadocokinesia: "Adiadocokinesia",
  emotionalChanges: "Emotional Changes",
  specialTest: "Any Special Test Required",

  // Lung Function Test
  fvcPredicted: "Predicted",
  fvcPerformed: "Performed",
  fvcPercentage: "Percentage",

  fevPredicted: "Predicted",
  fevPerformed: "Performed",
  fevPercentage: "Percentage",

  fvcfevPredicted: "Predicted",
  fvcfevPerformed: "Performed",
  fvcfevPercentage: "Percentage",

  pefPredicted: "Predicted",
  pefPerformed: "Performed",
  pefPercentage: "Percentage",

  endosedSpirometoryReport: "Enclosed Spirometry Report",

  medicalOfficerName: "Medical Officer Name",
  degree: "Degree",
  designation1: "designation 1",
  designation2: "designation 2",
  regdNo1: "Regd. No",
  regdNoDetails1: "Regd No. Details",
  regdNo2: "Regd. No",
  regdNoDetails2: "Regd No. Details",

  ...newSMEFormLabelObj,
};

export const MEDICAL_FORM_RULES = [
  {
    field_name: "medicalResult",
    label: employeeFormLabel["medicalResult"],
    type: "string",
    isRequired: true,
  },
  {
    field_name: "medicalTestType",
    label: employeeFormLabel["medicalTestType"],
    type: "string",
    isRequired: true,
  },

  {
    field_name: "medicalAssigneeId",
    label: employeeFormLabel["medicalAssigneeId"],
    type: "string",
    isRequired: true,
  },
  {
    field_name: "fatherName",
    label: employeeFormLabel["fatherName"],
    type: "string",
    isRequired: false,
  },
  {
    field_name: "dob",
    label: employeeFormLabel["dob"],
    type: "string",
    isRequired: false,
  },
  // {
  //   field_name: "identificationMarks",
  //   label: employeeFormLabel["identificationMarks"],
  //   type: "string",
  //   isRequired: true,
  // },
  {
    field_name: "aadharNumber",
    label: employeeFormLabel["aadharNumber"],
    type: "string",
    isRequired: false,
  },
  {
    field_name: "categoryId",
    label: employeeFormLabel["categoryId"],
    type: "string",
    isRequired: true,
  },
  {
    field_name: "subCategoryId",
    label: employeeFormLabel["subCategoryId"],
    type: "string",
    isRequired: true,
  },

  // ****** Form O ***** //
];

export const FORM_O_RULES = [
  {
    field_name: "identificationMark",
    label: employeeFormLabel["identificationMark"],
    type: "string",
    isRequired: true,
    tab: 1,
  },
  {
    field_name: "generalDevelopment",
    label: employeeFormLabel["generalDevelopment"],
    type: "string",
    isRequired: true,
    tab: 1,
  },
  {
    field_name: "height",
    label: employeeFormLabel["height"],
    type: "number",
    nonNegative: true,
    isRequired: true,
    tab: 1,
  },
  {
    field_name: "weight",
    label: employeeFormLabel["weight"],
    type: "number",
    nonNegative: true,
    isRequired: true,
    tab: 1,
  },

  {
    field_name: "visualAcuityLeftEye",
    label: employeeFormLabel["visualAcuityLeftEye"],
    type: "string",
    isRequired: true,
    tab: 2,
  },
  {
    field_name: "visualAcuityRightEye",
    label: employeeFormLabel["visualAcuityRightEye"],
    type: "string",
    isRequired: true,
    tab: 2,
  },
  {
    field_name: "nearVisionLeftEye",
    label: employeeFormLabel["visualAcuityLeftEye"],
    type: "string",
    isRequired: true,
    tab: 2,
  },
  {
    field_name: "nearVisionRightEye",
    label: employeeFormLabel["visualAcuityRightEye"],
    type: "string",
    isRequired: true,
    tab: 2,
  },
  {
    field_name: "organicDiseaseOfEyes",
    label: employeeFormLabel["organicDiseaseOfEyes"],
    type: "string",
    isRequired: true,
    tab: 2,
  },
  {
    field_name: "nightBlindness",
    label: employeeFormLabel["nightBlindness"],
    type: "string",
    isRequired: true,
    tab: 2,
  },
  {
    field_name: "colourBlindness",
    label: employeeFormLabel["colourBlindness"],
    type: "string",
    isRequired: true,
    tab: 2,
  },
  {
    field_name: "squint",
    label: employeeFormLabel["squint"],
    type: "string",
    isRequired: true,
    tab: 2,
  },
  {
    field_name: "testForSquintPerformed",
    label: employeeFormLabel["testForSquintPerformed"],
    type: "string",
    isRequired: true,
    tab: 2,
  },

  {
    field_name: "hearingLeftEar",
    label: employeeFormLabel["hearingLeftEar"],
    type: "string",
    isRequired: true,
    tab: 3,
  },
  {
    field_name: "hearingRightEar",
    label: employeeFormLabel["hearingRightEar"],
    type: "string",
    isRequired: true,
    tab: 3,
  },
  {
    field_name: "organicDiseaseOfEar",
    label: employeeFormLabel["organicDiseaseOfEar"],
    type: "string",
    isRequired: true,
    tab: 3,
  },

  {
    field_name: "chestAfterFullInspiration",
    label: employeeFormLabel["chestAfterFullInspiration"],
    type: "string",
    isRequired: true,
    tab: 4,
  },
  {
    field_name: "chestAfterFullExpiration",
    label: employeeFormLabel["chestAfterFullExpiration"],
    type: "string",
    isRequired: true,
    tab: 4,
  },
  {
    field_name: "bloodPressure",
    label: employeeFormLabel["bloodPressure"],
    type: "number",
    nonNegative: true,
    isRequired: true,
    tab: 5,
  },
  {
    field_name: "bloodPressureDiastolic",
    label: employeeFormLabel["bloodPressureDiastolic"],
    type: "number",
    nonNegative: true,
    isRequired: true,
    tab: 5,
  },
  {
    field_name: "pulse",
    label: employeeFormLabel["pulse"],
    type: "number",
    nonNegative: true,
    isRequired: true,
    tab: 5,
  },

  {
    field_name: "tenderness",
    label: employeeFormLabel["tenderness"],
    type: "string",
    isRequired: true,
    tab: 6,
  },
  {
    field_name: "liver",
    label: employeeFormLabel["liver"],
    type: "string",
    isRequired: true,
    tab: 6,
  },
  {
    field_name: "spleen",
    label: employeeFormLabel["spleen"],
    type: "string",
    isRequired: true,
    tab: 6,
  },
  {
    field_name: "tumor",
    label: employeeFormLabel["tumor"],
    type: "string",
    isRequired: true,
    tab: 6,
  },

  {
    field_name: "epilepsy",
    label: employeeFormLabel["epilepsy"],
    type: "string",
    isRequired: true,
    tab: 7,
  },
  {
    field_name: "paralysis",
    label: employeeFormLabel["paralysis"],
    type: "string",
    isRequired: true,
    tab: 7,
  },
  {
    field_name: "mentalHealth",
    label: employeeFormLabel["mentalHealth"],
    type: "string",
    isRequired: true,
    tab: 7,
  },

  {
    field_name: "locomotorySystem",
    label: employeeFormLabel["locomotorySystem"],
    type: "string",
    isRequired: true,
    tab: 9,
  },
  {
    field_name: "skin",
    label: employeeFormLabel["skin"],
    type: "string",
    isRequired: true,
    tab: 9,
  },
  {
    field_name: "hydrocele",
    label: employeeFormLabel["hydrocele"],
    type: "string",
    isRequired: true,
    tab: 9,
  },
  {
    field_name: "hernia",
    label: employeeFormLabel["hernia"],
    type: "string",
    isRequired: true,
    tab: 9,
  },
  {
    field_name: "anyOtherAbnormality",
    label: employeeFormLabel["anyOtherAbnormality"],
    type: "string",
    isRequired: true,
    tab: 9,
  },
  {
    field_name: "skiagramOfChest",
    label: employeeFormLabel["skiagramOfChest"],
    type: "string",
    isRequired: true,
    tab: 9,
  },
  {
    field_name: "anyOtherTest",
    label: employeeFormLabel["anyOtherTest"],
    type: "string",
    isRequired: true,
    tab: 10,
  },
  {
    field_name: "anyOpinion",
    label: employeeFormLabel["anyOpinion"],
    type: "string",
    isRequired: true,
    tab: 10,
  },

  {
    field_name: "reaction",
    label: employeeFormLabel["reaction"],
    type: "string",
    isRequired: true,
    tab: 8,
  },

  {
    field_name: "albumin",
    label: employeeFormLabel["albumin"],
    type: "string",
    isRequired: true,
    tab: 8,
  },
  {
    field_name: "sugar",
    label: employeeFormLabel["sugar"],
    type: "string",
    isRequired: true,
    tab: 8,
  },

  {
    field_name: "isSufferingFrom",
    label: employeeFormLabel["isSufferingFrom"],
    type: "string",
    isRequired: true,
    tab: 11,
  },
  {
    field_name: "repeatExaminationAfter",
    label: employeeFormLabel["repeatExaminationAfter"],
    type: "string",
    isRequired: true,
    tab: 11,
  },
  {
    field_name: "reExaminationRequirement",
    label: employeeFormLabel["reExaminationRequirement"],
    type: "string",
    isRequired: true,
    tab: 11,
  },
  {
    field_name: "examinationRequirementText",
    label: "Field",
    type: "string",
    isRequired: false,
    tab: 11,
  },
  {
    field_name: "phyisicanSpecialist",
    label: employeeFormLabel["phyisicanSpecialist"],
    type: "string",
    isRequired: true,
    tab: 11,
  },
  {
    field_name: "permittedDuties",
    label: employeeFormLabel["permittedDuties"],
    type: "string",
    isRequired: true,
    tab: 11,
  },
  {
    field_name: "specialRemarks",
    label: employeeFormLabel["remarks"],
    type: "string",
    isRequired: true,
    tab: 11,
  },
];

export const SME_FORM_RULES = [
  // ****** SME ***** //

  {
    field_name: "auscultationS1",
    label: employeeFormLabel["auscultationS1"],
    type: "string",
    isRequired: true,
    tab: 1,
  },
  {
    field_name: "auscultationS2",
    label: employeeFormLabel["auscultationS2"],
    type: "string",
    isRequired: true,
    tab: 1,
  },
  {
    field_name: "additionalSound",
    label: employeeFormLabel["additionalSound"],
    type: "string",
    isRequired: true,
    tab: 1,
  },
  {
    field_name: "electrocardiogram",
    label: employeeFormLabel["electrocardiogram"],
    type: "string",
    isRequired: true,
    tab: 1,
  },
  {
    field_name: "superficialReflexes",
    label: employeeFormLabel["superficialReflexes"],
    type: "string",
    isRequired: true,
    tab: 2,
  },
  {
    field_name: "deepReflexes",
    label: employeeFormLabel["deepReflexes"],
    type: "string",
    isRequired: true,
    tab: 2,
  },
  {
    field_name: "peripheralCirculation",
    label: employeeFormLabel["peripheralCirculation"],
    type: "string",
    isRequired: true,
    tab: 2,
  },
  {
    field_name: "vibrationalSyndromes",
    label: employeeFormLabel["vibrationalSyndromes"],
    type: "string",
    isRequired: true,
    tab: 2,
  },
  {
    field_name: "profusion",
    label: employeeFormLabel["profusion"],
    type: "string",
    isRequired: true,
    tab: 3,
  },
  {
    field_name: "grades",
    label: employeeFormLabel["grades"],
    type: "string",
    isRequired: true,
    tab: 3,
  },
  {
    field_name: "types",
    label: employeeFormLabel["types"],
    type: "string",
    isRequired: true,
    tab: 3,
  },

  {
    field_name: "leftEarConduction",
    label: employeeFormLabel["leftEarConduction"],
    type: "string",
    isRequired: true,
    tab: 4,
  },
  {
    field_name: "rightEarConduction",
    label: employeeFormLabel["rightEarConduction"],
    type: "string",
    isRequired: true,
    tab: 4,
  },
  {
    field_name: "leftEarBoneConduction",
    label: employeeFormLabel["leftEarBoneConduction"],
    type: "string",
    isRequired: true,
    tab: 4,
  },
  {
    field_name: "rightEarBoneConduction",
    label: employeeFormLabel["rightEarBoneConduction"],
    type: "string",
    isRequired: true,
    tab: 4,
  },
  {
    field_name: "blood",
    label: employeeFormLabel["blood"],
    type: "string",
    isRequired: true,
    tab: 5,
  },
  {
    field_name: "bloodDc",
    label: employeeFormLabel["bloodDc"],
    type: "string",
    isRequired: true,
    tab: 5,
  },
  {
    field_name: "bloodHb",
    label: employeeFormLabel["bloodHb"],
    type: "string",
    isRequired: true,
    tab: 5,
  },
  {
    field_name: "bloodESR",
    label: employeeFormLabel["bloodESR"],
    type: "string",
    isRequired: true,
    tab: 5,
  },
  {
    field_name: "bloodPlatelets",
    label: employeeFormLabel["bloodPlatelets"],
    type: "string",
    isRequired: true,
    tab: 5,
  },
  {
    field_name: "bloodSugar",
    label: employeeFormLabel["bloodSugar"],
    type: "string",
    isRequired: true,
    tab: 5,
  },
  {
    field_name: "bloodSugarPP",
    label: employeeFormLabel["bloodSugarPP"],
    type: "string",
    isRequired: true,
    tab: 5,
  },
  {
    field_name: "lipidProfile",
    label: employeeFormLabel["lipidProfile"],
    type: "string",
    nonNegative: true,
    isRequired: true,
    tab: 5,
  },
  {
    field_name: "bloodUrea",
    label: employeeFormLabel["bloodUrea"],
    type: "string",
    nonNegative: true,
    isRequired: true,
    tab: 5,
  },
  {
    field_name: "creatinine",
    label: employeeFormLabel["creatinine"],
    type: "string",
    nonNegative: true,
    isRequired: true,
    tab: 5,
  },

  {
    field_name: "urineRoutine",
    label: employeeFormLabel["urineRoutine"],
    type: "string",
    isRequired: true,
    tab: 5,
  },
  {
    field_name: "stoolRoutine",
    label: employeeFormLabel["stoolRoutine"],
    type: "string",
    isRequired: true,
    tab: 5,
  },
  {
    field_name: "behaviorDisturbances",
    label: employeeFormLabel["behaviorDisturbances"],
    type: "string",
    isRequired: true,
    tab: 6,
  },
  {
    field_name: "speechDefect",
    label: employeeFormLabel["speechDefect"],
    type: "string",
    isRequired: true,
    tab: 6,
  },

  {
    field_name: "tremor",
    label: employeeFormLabel["tremor"],
    type: "string",
    isRequired: true,
    tab: 6,
  },
  {
    field_name: "adiadocokinesia",
    label: employeeFormLabel["adiadocokinesia"],
    type: "string",
    isRequired: true,
    tab: 6,
  },
  {
    field_name: "emotionalChanges",
    label: employeeFormLabel["emotionalChanges"],
    type: "string",
    isRequired: true,
    tab: 6,
  },

  {
    field_name: "specialTest",
    label: employeeFormLabel["specialTest"],
    type: "string",
    isRequired: false,
    tab: 7,
  },
  {
    field_name: "fvcPredicted",
    label: employeeFormLabel["fvcPredicted"],
    type: "string",
    isRequired: true,
    tab: 8,
  },
  {
    field_name: "fvcPerformed",
    label: employeeFormLabel["fvcPerformed"],
    type: "string",
    isRequired: true,
    tab: 8,
  },
  {
    field_name: "fvcPercentage",
    label: employeeFormLabel["fvcPercentage"],
    type: "string",
    isRequired: true,
    tab: 8,
  },
  {
    field_name: "fevPredicted",
    label: employeeFormLabel["fevPredicted"],
    type: "string",
    isRequired: true,
    tab: 8,
  },
  {
    field_name: "fevPerformed",
    label: employeeFormLabel["fevPerformed"],
    type: "string",
    isRequired: true,
    tab: 8,
  },
  {
    field_name: "fevPercentage",
    label: employeeFormLabel["fevPercentage"],
    type: "string",
    isRequired: true,
    tab: 8,
  },
  {
    field_name: "fvcfevPredicted",
    label: employeeFormLabel["fvcfevPredicted"],
    type: "string",
    isRequired: true,
    tab: 8,
  },
  {
    field_name: "fvcfevPerformed",
    label: employeeFormLabel["fvcfevPerformed"],
    type: "string",
    isRequired: true,
    tab: 8,
  },
  {
    field_name: "fvcfevPercentage",
    label: employeeFormLabel["fvcfevPercentage"],
    type: "string",
    isRequired: true,
    tab: 8,
  },
  {
    field_name: "pefPredicted",
    label: employeeFormLabel["pefPredicted"],
    type: "string",
    isRequired: true,
    tab: 8,
  },
  {
    field_name: "pefPerformed",
    label: employeeFormLabel["pefPerformed"],
    type: "string",
    isRequired: true,
    tab: 8,
  },
  {
    field_name: "pefPercentage",
    label: employeeFormLabel["pefPercentage"],
    type: "string",
    isRequired: true,
    tab: 8,
  },
  {
    field_name: "endosedSpirometoryReport",
    label: employeeFormLabel["endosedSpirometoryReport"],
    type: "string",
    isRequired: false,
    tab: 8,
  },
  {
    field_name: "remarks",
    label: employeeFormLabel["remarks"],
    type: "string",
    isRequired: false,
    tab: 9,
  },
];

export const Manganese_Exposure_RULES = [
  {
    field_name: "neurologicalDisturbancesObservations",
    label: employeeFormLabel["neurologicalDisturbancesObservations"],
    type: "string",
    isRequired: true,
    tab: 1,
  },
  {
    field_name: "behaviouralDisturbancesObservations",
    label: employeeFormLabel["behaviouralDisturbancesObservations"],
    type: "string",
    isRequired: true,
    tab: 1,
  },
  {
    field_name: "speechDefectObservations",
    label: employeeFormLabel["speechDefectObservations"],
    type: "number",
    nonNegative: true,
    isRequired: true,
    tab: 1,
  },
  {
    field_name: "tremorObservations",
    label: employeeFormLabel["tremorObservations"],
    type: "number",
    nonNegative: true,
    isRequired: true,
    tab: 1,
  },

  {
    field_name: "impairmentOfEquilibrium",
    label: employeeFormLabel["impairmentOfEquilibrium"],
    type: "string",
    isRequired: true,
    tab: 1,
  },
  {
    field_name: "adiadochokinesiaH2SObservations",
    label: employeeFormLabel["adiadochokinesiaH2SObservations"],
    type: "string",
    isRequired: true,
    tab: 1,
  },
  {
    field_name: "emotionalObservations",
    label: employeeFormLabel["emotionalObservations"],
    type: "string",
    isRequired: true,
    tab: 1,
  },
  {
    field_name: "manganeseEnclosedReports",
    label: employeeFormLabel["manganeseEnclosedReports"],
    type: "string",
    isRequired: true,
    tab: 1,
  },
];

export const Lead_Exposure_RULES = [
  {
    field_name: "bloodLeadCount",
    label: employeeFormLabel["bloodLeadCount"],
    type: "string",
    isRequired: true,
    tab: 2,
  },
  {
    field_name: "bloodLeadAnalysisObservations",
    label: employeeFormLabel["bloodLeadAnalysisObservations"],
    type: "string",
    isRequired: true,
    tab: 2,
  },
  {
    field_name: "deltaAminolevulinicAcidCount",
    label: employeeFormLabel["deltaAminolevulinicAcidCount"],
    type: "number",
    nonNegative: true,
    isRequired: true,
    tab: 2,
  },
  {
    field_name: "deltaAminolevulinicAcidObservations",
    label: employeeFormLabel["deltaAminolevulinicAcidObservations"],
    type: "number",
    nonNegative: true,
    isRequired: true,
    tab: 2,
  },

  {
    field_name: "leadEnclosedReports",
    label: employeeFormLabel["leadEnclosedReports"],
    type: "string",
    isRequired: true,
    tab: 2,
  },
];

export const Ionizing_Radiation_Exposure_RULES = [
  {
    field_name: "radiationBloodCount",
    label: employeeFormLabel["radiationBloodCount"],
    type: "string",
    isRequired: true,
    tab: 3,
  },
  {
    field_name: "bloodRadiationObservations",
    label: employeeFormLabel["bloodRadiationObservations"],
    type: "string",
    isRequired: true,
    tab: 3,
  },
  {
    field_name: "pathologicalManifestationObservations",
    label: employeeFormLabel["pathologicalManifestationObservations"],
    type: "number",
    nonNegative: true,
    isRequired: true,
    tab: 3,
  },
  {
    field_name: "ionizingEnclosedReports",
    label: employeeFormLabel["ionizingEnclosedReports"],
    type: "number",
    nonNegative: true,
    isRequired: true,
    tab: 3,
  },
];

export const Food_Handling_RULES = [
  {
    field_name: "routineStoolTestObservations",
    label: employeeFormLabel["routineStoolTestObservations"],
    type: "string",
    isRequired: true,
    tab: 4,
  },
  {
    field_name: "AFPSputum",
    label: employeeFormLabel["AFPSputum"],
    type: "string",
    isRequired: true,
    tab: 4,
  },
  {
    field_name: "AFPSputumAnalysis",
    label: employeeFormLabel["AFPSputumAnalysis"],
    type: "number",
    nonNegative: true,
    isRequired: true,
    tab: 4,
  },
  {
    field_name: "chestRadiographObservations",
    label: employeeFormLabel["chestRadiographObservations"],
    type: "number",
    nonNegative: true,
    isRequired: true,
    tab: 4,
  },
  {
    field_name: "foodHandingEnclosedReports",
    label: employeeFormLabel["foodHandingEnclosedReports"],
    type: "number",
    nonNegative: true,
    isRequired: true,
    tab: 4,
  },
];

export const Driving_RULES = [
  {
    field_name: "visualAcuityLeftEye",
    label: employeeFormLabel["visualAcuityLeftEye"],
    type: "string",
    isRequired: true,
    tab: 5,
  },
  {
    field_name: "visualAcuityRightEye",
    label: employeeFormLabel["visualAcuityRightEye"],
    type: "string",
    isRequired: true,
    tab: 5,
  },
  {
    field_name: "nearVisionLeftEye",
    label: employeeFormLabel["visualAcuityLeftEye"],
    type: "string",
    isRequired: true,
    tab: 5,
  },
  {
    field_name: "nearVisionRightEye",
    label: employeeFormLabel["visualAcuityRightEye"],
    type: "string",
    isRequired: true,
    tab: 5,
  },
  {
    field_name: "organicDiseaseOfEyes",
    label: employeeFormLabel["organicDiseaseOfEyes"],
    type: "string",
    isRequired: true,
    tab: 5,
  },
  {
    field_name: "nightBlindness",
    label: employeeFormLabel["nightBlindness"],
    type: "string",
    isRequired: true,
    tab: 5,
  },
  {
    field_name: "colourBlindness",
    label: employeeFormLabel["colourBlindness"],
    type: "string",
    isRequired: true,
    tab: 5,
  },
  {
    field_name: "squint",
    label: employeeFormLabel["squint"],
    type: "string",
    isRequired: true,
    tab: 5,
  },
  {
    field_name: "testForSquintPerformed",
    label: employeeFormLabel["testForSquintPerformed"],
    type: "string",
    isRequired: true,
    tab: 5,
  },
];

export const Noise_Exposure_RULES = [
  {
    field_name: "leftEarConduction",
    label: employeeFormLabel["leftEarConduction"],
    type: "string",
    isRequired: true,
    tab: 6,
  },
  {
    field_name: "rightEarConduction",
    label: employeeFormLabel["rightEarConduction"],
    type: "string",
    isRequired: true,
    tab: 6,
  },
  {
    field_name: "leftEarBoneConduction",
    label: employeeFormLabel["leftEarBoneConduction"],
    type: "string",
    isRequired: true,
    tab: 6,
  },
  {
    field_name: "rightEarBoneConduction",
    label: employeeFormLabel["rightEarBoneConduction"],
    type: "string",
    isRequired: true,
    tab: 6,
  },
  {
    field_name: "audiometryAnalysis",
    label: employeeFormLabel["audiometryAnalysis"],
    type: "string",
    isRequired: true,
    tab: 6,
  },
  {
    field_name: "noiseRemarks",
    label: employeeFormLabel["noiseRemarks"],
    type: "string",
    isRequired: true,
    tab: 6,
  },
  {
    field_name: "noiseEnclosedReports",
    label: employeeFormLabel["noiseEnclosedReports"],
    type: "string",
    isRequired: true,
    tab: 6,
  },
];

export const Chemicals_Exposure_RULES = [
  {
    field_name: "anyDirectContactWithChemicals",
    label: employeeFormLabel["anyDirectContactWithChemicals"],
    type: "string",
    isRequired: true,
    tab: 7,
  },
  {
    field_name: "contactDermatitisObservations",
    label: employeeFormLabel["contactDermatitisObservations"],
    type: "string",
    isRequired: true,
    tab: 7,
  },
  {
    field_name: "chemicalsRemarks",
    label: employeeFormLabel["chemicalsRemarks"],
    type: "string",
    isRequired: true,
    tab: 7,
  },
  {
    field_name: "chemicalsEnclosedReports",
    label: employeeFormLabel["chemicalsEnclosedReports"],
    type: "string",
    isRequired: true,
    tab: 7,
  },
];

export const Pneumoconiosis_Information_RULES = [
  {
    field_name: "pneumoconiosisObservations",
    label: employeeFormLabel["pneumoconiosisObservations"],
    type: "string",
    isRequired: true,
    tab: 8,
  },
  {
    field_name: "siderosisObservations",
    label: employeeFormLabel["siderosisObservations"],
    type: "string",
    isRequired: true,
    tab: 8,
  },
  {
    field_name: "berillyosisObservations",
    label: employeeFormLabel["berillyosisObservations"],
    type: "string",
    isRequired: true,
    tab: 8,
  },
  {
    field_name: "anyOtherObservation",
    label: employeeFormLabel["anyOtherObservation"],
    type: "string",
    isRequired: true,
    tab: 8,
  },
  {
    field_name: "pneumoconiosisRemarks",
    label: employeeFormLabel["pneumoconiosisRemarks"],
    type: "string",
    isRequired: true,
    tab: 8,
  },
  {
    field_name: "pneumoconiosisEnclosedReports",
    label: employeeFormLabel["pneumoconiosisEnclosedReports"],
    type: "string",
    isRequired: true,
    tab: 8,
  },
];

export const employeeType = (type) => {
  return type === "employee"
    ? "Employee ID"
    : type === "contractorPerson"
    ? "Contractor Person ID"
    : "Employee ID/Contractor Person ID";
};

export const medicalFilterFields = [
  {
    name: "siteId",
    title: "Location",
    inputType: EFormFieldInputTypes.searchableSelect,
  },
  {
    name: "medicalTestType",
    title: "Medical Type",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: Object.keys(MEDICAL_TYPE_VIEW).map((k) => ({
      label: MEDICAL_TYPE_VIEW[k],
      value: k,
    })),
  },
  {
    name: "medicalAssigneeTypeView",
    title: "Staff Type",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: Object.keys({ all: "All", ...TRAINEE_TYPE }).map((key) => ({
      label: { all: "All", ...TRAINEE_TYPE }[key],
      value: { all: "All", ...TRAINEE_TYPE }[key],
    })),
  },
  {
    name: "assigneeName",
    title: "Name",
    inputType: EFormFieldInputTypes.searchableSelect,
  },
  {
    name: "assigneeID",
    title: "ID",
    inputType: EFormFieldInputTypes.searchableSelect,
  },
  {
    name: "formA",
    title: "Form A",
    inputType: EFormFieldInputTypes.text,
  },
  {
    name: "medicalStatus",
    title: "Status",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: Object.keys(MEDICAL_STATUS_VIEW).map((k) => ({
      label: MEDICAL_STATUS_VIEW[k],
      value: k,
    })),
  },
  {
    name: "medicalResult",
    title: "Report Status",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: Object.keys(MEDICAL_REPORT_STATUS_VIEW).map((k) => ({
      label: MEDICAL_REPORT_STATUS_VIEW[k],
      value: k,
    })),
  },
  {
    name: "dateRange",
    title: "Date Range",
    inputType: EFormFieldInputTypes.dateRange,
  },
];
export const medicalFilterFieldsAllMedical = [
  {
    name: "siteId",
    title: "Location",
    inputType: EFormFieldInputTypes.searchableSelect,
  },
  // {
  //   name: "medicalTestType",
  //   title: "Medical Type",
  //   inputType: EFormFieldInputTypes.searchableSelect,
  //   options: Object.keys(MEDICAL_TYPE_VIEW).map((k) => ({
  //     label: MEDICAL_TYPE_VIEW[k],
  //     value: k,
  //   })),
  // },
  {
    name: "medicalAssigneeTypeView",
    title: "Staff Type",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: Object.keys({ all: "All", ...TRAINEE_TYPE }).map((key) => ({
      label: { all: "All", ...TRAINEE_TYPE }[key],
      value: { all: "All", ...TRAINEE_TYPE }[key],
    })),
  },
  {
    name: "assigneeName",
    title: "Name",
    inputType: EFormFieldInputTypes.searchableSelect,
  },
];

export const medicalDueFilterFields = [
  {
    name: "medicalAssigneeTypeView",
    title: "Emp Type",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: Object.keys({ all: "All", ...TRAINEE_TYPE }).map((key) => ({
      label: { all: "All", ...TRAINEE_TYPE }[key],
      value: { all: "All", ...TRAINEE_TYPE }[key],
    })),
  },
  {
    name: "assigneeName",
    title: "Name",
    inputType: EFormFieldInputTypes.searchableSelect,
  },
  {
    name: "formA",
    title: "Form A",
    inputType: EFormFieldInputTypes.text,
  },
  // {
  //   name: "categoryId",
  //   title: "Skill Category",
  //   inputType: EFormFieldInputTypes.searchableSelect,
  // },
  {
    name: "assigneeID",
    title: "ID",
    inputType: EFormFieldInputTypes.searchableSelect,
  },
  {
    name: "medicalStatus",
    title: "Status",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: Object.keys(MEDICAL_STATUS_VIEW).map((k) => ({
      label: MEDICAL_STATUS_VIEW[k],
      value: k,
    })),
  },
];

export const validateMedicalRowFilter = (obj, filterForm) => {
  let flag = true;
  if (filterForm?.medicalAssigneeTypeView === "All") flag = true;
  if (filterForm?.medicalResult === "all") flag = true;
  if (filterForm?.medicalStatus === "all") flag = true;

  if (filterForm?.startDate && filterForm?.endDate) {
    flag = isBetween(
      YYYYMMDDFormat(obj?.completionDate),
      YYYYMMDDFormat(filterForm?.startDate),
      YYYYMMDDFormat(filterForm?.endDate)
    );
  }

  if (flag) {
    for (const key in filterForm) {
      if (
        (key === "medicalAssigneeTypeView" &&
          filterForm?.medicalAssigneeTypeView === "All") ||
        (key === "medicalResult" && filterForm?.medicalResult === "all") ||
        (key === "medicalStatus" && filterForm?.medicalStatus === "all") ||
        key === "startDate" ||
        key === "endDate" ||
        !filterForm[key]
      )
        continue;

      if (key !== "formA" && obj[key] !== filterForm[key]) return (flag = false);
      else if (
        key === "formA" &&
        !obj[key]?.toLowerCase()?.includes(filterForm[key]?.toLowerCase())
      )
        return (flag = false);
    }

    return (flag = true);
  }
  return flag;
};

export const MD_STATUS = {
  due: "due",
  overdue: "Over Due",
  soReview: "SO Review",
  completed: "Completed",
  mmReview: "MM Review",
  approved: "Approved",
  fit: "fit",
  unfit: "unfit",
};

export const getMedicalStatusClass = (status) => {
  switch (status) {
    case MD_STATUS.due:
      return "yellow text-white rounded text-center px-1";
    case MD_STATUS.overdue:
      return "red text-white rounded text-center px-1";
    case MD_STATUS.soReview:
      return "orange text-white rounded text-center px-1";
    case MD_STATUS.mmReview:
      return "orange text-white rounded text-center px-1";
    case MD_STATUS.executed:
      return "green-300 text-white rounded text-center";
    case MD_STATUS.completed:
      return "success";
    case MD_STATUS.approved:
      return "success";
    case MD_STATUS.fit:
      return "success";
    case MD_STATUS.unfit:
      return "red text-white rounded text-center px-1";
    default:
      return "success";
  }
};

export const tabTypeObj = {
  2: "ime",
  3: "pme",
  4: "sme",
};
